export default "https://cdn-static.gokick.com/assets/ea2c661fec3366c14365f7d1c68d2a3d0c715dc9/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";